import update from "immutability-helper";

import client from "lib/apolloClient/client";
import _ from "lodash";
import { graphql } from "lib/apolloClient";
import {
  productRequestMutation,
  resetProductUpdateReadCountMutation,
} from "./ProductUpdatesV2Mutations";

import { getProductUpdateModulesQuery } from "./ProductUpdatesV2Queries";

//To prevent re-renders if array is empty
const EMPTY_ARRAY = [];

import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

export const productRequest = ({
  productRequestInput,
  isFeatureAvailableForRequest = false,
}) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: productRequestMutation,
        variables: {
          input: {
            ...productRequestInput,
          },
        },
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: isFeatureAvailableForRequest
            ? "toastMsgs:request_submitted_successfully"
            : "toastMsgs:successfully_with_label",
          locale_params: isFeatureAvailableForRequest
            ? []
            : [
                {
                  key: "label",
                  value: "common:request_for_beta",
                  isPlainText: false,
                },
              ],
        })
      );
      return true;
    } catch (e) {
      console.error(e);
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const resetProductUpdateReadCount = ({ filters }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: resetProductUpdateReadCountMutation,
        variables: {
          input: {
            ...filters,
          },
        },
      });
    } catch (e) {
      console.error(e);
    }
  };
};

export const getProductUpdateItems = ({ productUpdateFeedItem }) => {
  const groupedByModuleAndVersion = _.groupBy(
    _.get(productUpdateFeedItem, "releaseItems"),
    item =>
      `${_.get(item, "module.moduleKey")}-${_.get(item, "version")}-${_.get(
        item,
        "isBetaRequestAllowed"
      )}`
  );
  const groupedProductUpdateItems = _.sortBy(
    _.flatMap(groupedByModuleAndVersion, (items, key) => {
      const [moduleLabel, version, isBetaRequestAllowed] = key.split("-");
      return {
        moduleLabel,
        version,
        isBetaRequestAllowed,
        releaseItems: _.sortBy(items, "displaySequence"), // Sort items by displaySequence
      };
    }),
    ["moduleLabel", "isBeta"]
  );
  const betaProductUpdateItems = _.filter(
    [...groupedProductUpdateItems],
    item => _.get(item, "isBetaRequestAllowed") === "true"
  );
  return {
    groupedProductUpdateItems,
    betaProductUpdateItems,
  };
};

// action types
export const NAME = "productUpdatesV2";
export const UPDATE_FILTER = "UPDATE_FILTER" + " " + NAME;

// actions
export const updateProductFeedFilters = payload => {
  return { type: UPDATE_FILTER, payload };
};

// reducers
const REDUCER_HANDLERS = {
  [UPDATE_FILTER]: (state, action) => {
    return update(state, {
      filters: { $set: action.payload },
    });
  },
};

// initial state
const initialState = {
  filters: {
    curriculumPlan: [],
    moduleIds: [],
    searchText: "",
    filtersInitialized: false,
    selectedProductUpdateIndex: 0,
    productUpdateId: null,
    allModuleIds: [],
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export const getProductUpdateModulesEnhancer = () => {
  return graphql(getProductUpdateModulesQuery, {
    name: "productUpdatesModules",
    options: () => {
      return {
        fetchPolicy: "cache-first",
        variables: {
          filters: {
            fetchAll: false,
          },
        },
      };
    },
    props: ({
      productUpdatesModules,
      ownProps: { isData = false, isLoading = false } = {},
    }) => {
      const modules = _.get(productUpdatesModules, "cms.modules", EMPTY_ARRAY);

      return {
        modules,
        isData: isData && !_.isEmpty(modules),
        isLoading:
          _.includes([1, 2], productUpdatesModules?.networkStatus) || isLoading,
      };
    },
  });
};
